const QuestionIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.475 4.17499C11.3 2.52499 9.95001 1.17499 8.25001 0.949986C6.70001 0.774986 5.25001 1.54999 4.55001 2.89999C4.40001 3.17499 4.52501 3.52499 4.80001 3.64999C5.07501 3.79999 5.42501 3.67499 5.55001 3.39999C6.05001 2.44999 7.05001 1.92499 8.12501 2.02499C9.30001 2.17499 10.225 3.12499 10.35 4.24999C10.475 5.32499 9.90001 6.34999 8.92501 6.79999C7.90001 7.29999 7.25001 8.34999 7.25001 9.52499V12C7.25001 12.3 7.50001 12.575 7.82501 12.575C8.15001 12.575 8.40001 12.325 8.40001 12V9.52499C8.40001 8.79999 8.82501 8.12499 9.45001 7.82499C10.825 7.22499 11.65 5.72499 11.475 4.17499Z"
        fill="#9CA3AF"
      />
      <path
        d="M7.825 13.8C7.525 13.8 7.25 14.05 7.25 14.375V14.5C7.25 14.8 7.5 15.075 7.825 15.075C8.15 15.075 8.4 14.825 8.4 14.5V14.375C8.375 14.05 8.125 13.8 7.825 13.8Z"
        fill="#9CA3AF"
      />
    </svg>
  );
};

export default QuestionIcon;
